/**
 * @generated SignedSource<<e2a4bff171cd9b88d9de1ae4a5b48a17>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type DashboardBlockContentMode = "full" | "preview" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ContentDashboardBlockFragment$data = {
  readonly contentUsages: {
    readonly totalCount: number;
  } | null;
  readonly mode: DashboardBlockContentMode;
  readonly " $fragmentSpreads": FragmentRefs<"ContentDashboardBlockFullContentFragment" | "ContentDashboardBlockPreviewContentFragment" | "DashboardBlockItemTemplateFragment">;
  readonly " $fragmentType": "ContentDashboardBlockFragment";
};
export type ContentDashboardBlockFragment$key = {
  readonly " $data"?: ContentDashboardBlockFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentDashboardBlockFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentDashboardBlockFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentUsageNodeConnection",
      "kind": "LinkedField",
      "name": "contentUsages",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DashboardBlockItemTemplateFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContentDashboardBlockPreviewContentFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContentDashboardBlockFullContentFragment"
    }
  ],
  "type": "ContentDashboardBlock",
  "abstractKey": null
};

(node as any).hash = "42850b60760533ed822966ce8db6f495";

export default node;
